export function formatV0Comment(comment) {
  return {
    id: comment.id,
    author: {
      id: comment.commenter_user_id,
      username: comment.username,
    },
    content: comment.content,
    timePosted: new Date(comment.time_posted).toISOString(),
  };
}
